import styles from "./styles.module.css";
import { useEffect, useState } from "react";
export default function MinMax({ value, onChange }) {
  const [_value, _setValue] = useState({ min: 0, max: 1500 });
  const setValue = (v, key) => {
    const num = parseInt(v);
    const newValue = { ..._value };
    newValue[key] = isNaN(num) ? "" : num;
    _setValue(newValue);
  };

  const handleSave = () => {
    onChange(_value);
  };

  useEffect(() => {
    if (value) {
      _setValue(value);
    }
  }, [value]);
  return (
    <div style={{ position: "relative", width: "100%" }}>
      <div className={styles.rangeContainer}>
        <div style={{ marginRight: 4 }}>
          <div className={styles.rangeTitle}>Min</div>
          <input
            value={_value.min}
            onBlur={handleSave}
            onChange={(e) => setValue(e.target.value, "min")}
            className={`${styles.rangeInput} input`}
            min={0}
            max={_value.max}
            type="number"
          />
        </div>
        <div style={{ marginLeft: 4 }}>
          <div className={styles.rangeTitle}>Max</div>
          <input
            className={`${styles.rangeInput} input`}
            onBlur={handleSave}
            onChange={(e) => setValue(e.target.value, "max")}
            min={_value.min}
            value={_value.max}
            max={1500}
            type="number"
          />
        </div>
      </div>
    </div>
  );
}
